import { Component } from "../interface/component";

export class DesktopMenuComponent implements Component {

    private $root: JQuery;
    private $parents: JQuery;

    constructor(root: HTMLElement) {
        this.$root = $(root);
        this.$parents = this.$root.find('.js-primary-navigation__parent-navigation');
    }

    init() {
        this.$parents.on({
            mouseenter: this.handleHover,
            mouseleave: this.handleLeave,
        });
    }

    handleHover = (ev: MouseEvent) => {
        let $parent = $(ev.currentTarget);
        if ('false' === $parent.attr('aria-expanded') || undefined === $parent.attr('aria-expanded')) {
            let $submenu = $parent.find('.js-primary-navigation__sub-navigation');
            if (0 !== $submenu.length) {
                $parent.attr('aria-expanded', 'true');
                if (!$parent.hasClass('c-nav-list__item--subnav-active')) {
                    $parent.addClass('c-nav-list__item--subnav-activating');
                    $submenu.addClass('c-nav-sublist--expanding');
                }
                this.checkSubMenuPosition($submenu);
                setTimeout(() => {
                    if ('true' === $parent.attr('aria-expanded')) {
                        $submenu.addClass('c-nav-sublist--expanded');
                        $parent.addClass('c-nav-list__item--subnav-active');
                    }
                    $parent.removeClass('c-nav-list__item--subnav-activating');
                    $submenu.removeClass('c-nav-sublist--expanding');
                }, 100);
            }
        }
    }

    handleLeave = (ev: MouseEvent) => {
        let $parent = $(ev.currentTarget);
        if ('true' === $parent.attr('aria-expanded')) {
            $parent.attr('aria-expanded', 'false');
            let $submenu = $parent.find('.js-primary-navigation__sub-navigation');
            setTimeout(() => {
                if ('false' === $parent.attr('aria-expanded')) {
                    $parent.removeClass('c-nav-list__item--subnav-active');
                    $submenu.removeClass('c-nav-sublist--expanded');
                    this.resetSubMenuPosition($submenu);
                }
            }, 200);
        }
    }

    checkSubMenuPosition = ($submenu: JQuery) => {
        let boundingRect: DOMRect = $submenu.get(0).getBoundingClientRect();
        if (boundingRect.left < 20) {
            let $parent = $submenu.closest('.c-nav-list__item');
            let parentBoundingRect: DOMRect = $parent.get(0).getBoundingClientRect();
            let positionLeft = parentBoundingRect.left - 20;
            $submenu.addClass('c-nav-sublist--out-of-bounds');
            $submenu.css('left', -positionLeft);
        }
    }

    resetSubMenuPosition = ($submenu: JQuery) => {
        $submenu.removeClass('c-nav-sublist--out-of-bounds');
        $submenu.css('left', null);
    }
}
